import React from "react";
import { Check } from "lucide-react";

interface PremiumCheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const PremiumCheckbox: React.FC<PremiumCheckboxProps> = ({
  label,
  checked,
  onChange,
}) => (
  <label className="flex items-center gap-3 cursor-pointer group text-left">
    <div
      onClick={() => onChange(!checked)}
      className={`w-5 h-5 rounded-md border-2 flex items-center justify-center transition-all ${
        checked
          ? "bg-slate-900 border-slate-900"
          : "border-slate-300 group-hover:border-slate-400"
      }`}
    >
      {checked && <Check className="w-3 h-3 text-white" strokeWidth={3} />}
    </div>
    <span className="text-sm font-medium text-slate-700">{label}</span>
  </label>
);

export default PremiumCheckbox;
